<template>
    <!-- <ValidationErrors :show="showErrors"/> -->
    <Head :title="'Invoices - ' + fixture.title"/>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="activity_logs" />
    <div class="w-full mb-6">
        <FixtureHeader :fixture="fixture"></FixtureHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div v-if="invoices.length == 0" class="rounded-md bg-blue-50 p-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <InformationCircleIcon class="h-5 w-5 text-blue-400"
                                                                aria-hidden="true"/>
                                    </div>
                                    <div class="ml-3 space-y-3">
                                        <p class="text-sm text-blue-700">No invoices have been raised for this fixture.</p>
                                        <p class="text-sm text-blue-700">To raise an invoice, click on the <span class="underline"><Link :href="'quotes'">quotes</Link></span> tab and select the quote you wish to raise an invoice against.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Invoices</h3>
                                <div class="flex items-center">
                                    <search-filter :show-filter="false" v-model:value="form.search" @reset="reset"></search-filter>
                                </div>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <InvoiceList :invoices="invoices" :display_related_quotes="true "/>
                                    </div>
                                </div>
                            </div>

                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Commission Invoices</h3>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <InvoiceList :invoices="commission_invoices" :display_related_quotes="false" :invoice_type="'Commission'" />
                                    </div>
                                </div>
                            </div>

                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Management Fee Invoices</h3>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                        <InvoiceList :invoices="management_fee_invoices" :display_related_quotes="false" :invoice_type="'Management Fee'" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </section>
        </div>
    </div>
    <LinkInvoiceToSupplierInvoice/>
    <AddServiceLines ref="slideout_two" />
    <div id="commissionInvoiceAnchor"></div>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated";
import {Link, Head, useForm} from "@inertiajs/vue3";
import AddServiceLines from "@/Components/SlideOuts/AddServiceLines";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    CheckCircleIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import FixtureHeader from "@/Components/FixtureHeader";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import Button from "@/Components/Button";
import { router } from '@inertiajs/vue3'
import DuplicateQuote from "@/Components/SlideOuts/DuplicateQuote";
import InvoiceList from "@/Components/InvoiceList.vue";
import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";
import SearchFilter from "@/Components/SearchFilter";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import mapValues from 'lodash/mapValues';
import Audit from "@/Components/Modal/Audit.vue";

export default {
    layout: Authenticated,
    components: {
        LinkInvoiceToSupplierInvoice,
        DuplicateQuote,
        Button,
        CreateQuote,
        FixtureHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        InvoiceList,
        AddServiceLines,
        SearchFilter,
        Audit
    },
    props: {
        fixture: Object,
        invoices: Object,
        commission_invoices: Object,
        service_lines: Object,
        commission_invoice_created: Boolean,
        management_fee_invoices: Object,
        activity_logs: Array,
    },
    data(props) {
        return {
            form: useForm({}),
            openModal: false
        }
    },
    mounted() {
        this.commissionInvoiceCreated();
    },
    methods: {
        commissionInvoiceCreated() {
            if(this.commission_invoice_created) {
                setTimeout(function() { document.getElementById('commissionInvoiceAnchor').scrollIntoView({behavior: 'smooth'}) }, 1500);
            }
        },
        reset() {
            this.form = mapValues(this.form, () => null)
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function() {
                this.$inertia.get(route('frontend.fixture.invoice.index', [this.fixture.id]), pickBy(this.form), {preserveState: true, preserveScroll: true})
            }, 500),
        }
    }
}
</script>
